import React from 'react';
import { DialogContent, Box, CircularProgress } from '@mui/material';
import DialogModal from '../../../components/DialogModal';

interface ViewReceiptPdfDialogProps {
  open: boolean;
  onClose: () => void;
  pdfUrl: string | null;
  isLoading: boolean;
}

const ViewReceiptPdfDialog: React.FC<ViewReceiptPdfDialogProps> = ({
  open,
  onClose,
  pdfUrl,
  isLoading
}) => {
  return (
    <DialogModal
      open={open}
      onClose={onClose}
      title='View Receipt'
      maxWidth='lg'
      PaperPropsSx={{ height: '90vh' }}
    >
      <DialogContent sx={{ p: 0, height: '100%', width: '100%' }}>
        {isLoading ? (
          <Box
            display='flex'
            justifyContent='center'
            alignItems='center'
            height='100%'
          >
            <CircularProgress />
          </Box>
        ) : pdfUrl ? (
          <iframe
            src={pdfUrl}
            title='Receipt PDF'
            width='100%'
            height='100%'
            style={{ border: 'none' }}
          />
        ) : (
          <Box
            display='flex'
            justifyContent='center'
            alignItems='center'
            height='100%'
          >
            No PDF available.
          </Box>
        )}
      </DialogContent>
    </DialogModal>
  );
};

export default ViewReceiptPdfDialog;
